import { useClientId } from '../../_hooks/useClientId';

export const useLocalStorageKey = () => {
  const clientId = useClientId();

  return `permanent-${window.ADV.util.env('isAdviserArea')}-${clientId}-FinancialPlan`;
};
